export default __webpack_public_path__ + "static/media/img_14.44ce6a56.JPG";